import React from "react"
import Stepper from 'react-stepper-horizontal'
import "./step-progress.m.css"

export const StepProgress = (props) => {
    
    return(
        <div styleName="wrapper">
            <Stepper 
                steps={[
                    {title: 'Account'}, 
                    {title: 'Payment'}, 
                    {title: 'Confirmation'}, 
                ]} 
                size={20}
                circleFontSize={10}
                titleFontSize={15}
                circleTop={10}
                activeStep={ props.activeStep==="account"?0:props.activeStep==="payment"?1:2 } 
                completeBarColor={"#5096FF"}
            />
        </div> 
    )
}